import type { NuxtApp } from '#app'

// Sign-in / sign-out listeners for state that belongs to one shopper's session (AB#63454). Kept per app, so per
// request on the server. This module has no runtime imports on purpose: composables/auth.ts announces through it
// instead of importing the stores it clears. A direct import of the bonus selection store from auth.ts made Vitest's
// mockNuxtImport('$api') resolve to the real $api in specs that render the cart (the mock factory was already on the
// import stack via api.ts -> auth.ts -> store -> api.ts). A Nuxt runtime hook would fit, but a custom name does not
// type-check: augmenting RuntimeNuxtHooks through '#app' has no effect in this Nuxt version.
const listeners = new WeakMap<NuxtApp, Set<() => void>>()

// Registers a listener for the app's next sign-in or sign-out; returns its removal.
export const onSessionChange = (nuxtApp: NuxtApp, listener: () => void): (() => void) => {
  const appListeners = listeners.get(nuxtApp) ?? new Set<() => void>()
  listeners.set(nuxtApp, appListeners)
  appListeners.add(listener)
  return () => { appListeners.delete(listener) }
}

// Runs the app's listeners synchronously, so they have finished before login/logout navigates.
export const announceSessionChange = (nuxtApp: NuxtApp): void => {
  listeners.get(nuxtApp)?.forEach(listener => listener())
}
